/* @flow */

/**
 * @module idpmanager-stub
 * @description No-op IDP manager when ENABLE_IDP is false at compile time
 */

class _idpmanagerStub {
  init(w: WindowProxy, d: Document, g: globalParam) {}

  updateConfig(o: userIDsConfig) {}

  isUserIdEnabled(idpName: string = '', idpKey: string = ''): boolean {
    return false;
  }

  getUserID(idpName: string = '', idpKey: string = ''): string | Array<string> {
    return '';
  }

  getUserIDExt(idpName: string = '', idpKey: string = ''): anyObject {
    return {};
  }
}

const idp: _idpmanagerStub = new _idpmanagerStub();
export default idp;
